import React from 'react';
import styled from '@emotion/styled';

import { parseHtml } from '../helpers';

import { BulletPoint } from '../../types/types';

import { StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints, pxToRem } = StyleLibrary;

const Ul = styled.ul({
  paddingBottom: pxToRem(82),

  [mqBreakpoints.tablet]: {
    columnCount: 2,
  },
  [mqBreakpoints.desktop]: {
    columnCount: 3,
  },
});

const Li = styled.li({
  color: 'var(--color-white)',
  display: 'flex', // needed to prevent columns not aligning in Safari
});

type Props = {
  points: BulletPoint[];
};

export const SummaryPoints: React.FC<Props> = ({ points }) => {
  if (!(points && points.length)) {
    return null;
  }
  return (
    <Ul className='tick tick-lime' data-testid='mp-product-summary-points'>
      {points?.map((point, i) => (
        <Li key={i} className='tick-lime'>
          {parseHtml(point.title)}
        </Li>
      ))}
    </Ul>
  );
};
